import { NSARouterMakerResult } from "namirasoft-account-react";
import { PaymentProps } from "../PaymentProps";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { NSLoading } from "namirasoft-site-react";
import { PaymentRoutes } from "../PaymentRoutes";

export interface OfferItemViewPageProps extends NSARouterMakerResult, PaymentProps { }

function OfferItemViewPage(props: OfferItemViewPageProps)
{
    let { id } = useParams<{ id: string }>();

    useEffect(() =>
    {
        if (id)
            props.servers.payment.offer_item.Get(id).then(offer_item =>
            {
                props.url.redirect(PaymentRoutes.OfferView(offer_item.offer_id, false, ""), {})
            });
        // eslint-disable-next-line
    }, [id]);

    return <NSLoading />;
}

export default OfferItemViewPage;